"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._stateColor = _stateColor;
exports.default = Infobar;
var _utils = require("./utils");
var _Icon = _interopRequireDefault(require("./Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _stateColor(props) {
  if (props.primary || props.state === 'primary') return 'blue';
  if (props.secondary || props.state === 'secondary') return 'grey-blue';
  if (props.success || props.state === 'success') return 'green';
  if (props.info || props.state === 'info') return 'sky';
  if (props.warning || props.state === 'warning') return 'orange';
  if (props.error || props.state === 'error') return 'red';
  if (props.dark || props.state === 'dark') return 'dark';
  return props.color || 'default';
}
function Infobar(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-infobar', '-' + _stateColor(props), !props.m0 && 'mb-6', props.className)
  }, props.icon && /*#__PURE__*/React.createElement(_Icon.default, {
    name: props.icon,
    className: "_icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "_content"
  }, props.children));
}